// This file must be in shared-ui instead of rtl-ui so that Upsell::Tooltip can access the configs
import { t } from 'i18n';
export function getUpsellTooltipConfigs() {
  return {
    UNIT_COSTS_PLUS_VENDORS: {
      heading: t('retail.upsell.tooltip.unitCosts.title'),
      description: t('retail.upsell.tooltip.unitCosts.description'),
      imageConfig: {
        description: t('sharedUi.images.retail.upsell.tooltip.unitCostsPlusVendors.description'),
        responsiveImageSource: {
          '1x': '/@dashboard/rtl-ui/images/upsell/tooltip/unit-costs-and-vendors_US@1x.png',
          '2x': '/@dashboard/rtl-ui/images/upsell/tooltip/unit-costs-and-vendors_US@2x.png'
        },
        height: 148,
        width: 280
      }
    },
    COMPONENT_INVENTORY: {
      heading: t('retail.upsell.feature.componentInventory.title'),
      description: t('retail.upsell.feature.componentInventory.description'),
      imageConfig: {
        responsiveImageSource: {
          '1x': '/@dashboard/rtl-ui/images/upsell/tooltip/component-inventory.svg'
        },
        height: 60,
        width: 280
      }
    }
  };
}